<template>
    <div class="qa-list">
        <div class="header">
            <div class="go-back" @click="goBack">返回</div>
            <div class="line">|</div>
            <div>问答语料</div>
        </div>
        <div v-if="hasQa">
            <!-- 筛选行 -->
            <div class="select-box">
                <div class="select-item">
                    <div class="select-label">状态</div>
                    <div class="select-input status">
                        <veui-select
                            v-model="formData.status"
                            :options="statusList"
                            clearable
                            @change="handleSearch(1)"
                        />
                    </div>
                </div>
                <div class="select-item">
                    <div class="select-label">日期</div>
                    <div class="select-date">
                        <veui-date-picker
                            v-model="formData.date"
                            range
                            clearable
                            @select="handleSearch(1)"
                        />
                    </div>
                </div>
                <div class="select-item">
                    <div class="select-input name">
                        <veui-input
                            v-model="formData.question"
                            class="name-input"
                            placeholder="请输入问题描述"
                            @change="handleSearch(1)"
                        />
                    </div>
                </div>
                <div class="select-item">
                    <div class="select-label">领域</div>
                    <div class="select-domain">
                        <veui-select
                            v-model="formData.domain"
                            clearable
                            @change="handleSearch(1)"
                        >
                            <veui-option
                                v-for="(item) in doaminOption"
                                :key="item.code"
                                :label="item.name"
                                :value="item.name"
                                position="popup"
                            >
                            </veui-option>
                        </veui-select>
                    </div>
                </div>
            </div>
            <div class="operation-box">
                <veui-button
                    class="add-btn"
                    ui="primary"
                    @click="addQa"
                >新增问答</veui-button>
                <veui-button
                    class="remove-btn"
                    ui="basic"
                    :disabled="!selected || selected.length === 0"
                    @click="removeList"
                >批量移除知识库</veui-button>
            </div>
            <!-- 列表 -->
            <section class="content-list">
                <veui-table
                    :data="tableData"
                    key-field="id"
                    selectable
                    :selected.sync="selected"
                >
                    <veui-table-column
                        field="title"
                        width="250"
                        title="问题描述"
                    >
                        <template #default="{title}">
                            <div class="name">
                                <overflowTooltip
                                    :content="title"
                                    overflow-class="title"
                                />
                            </div>
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="knowledge_status"
                        title="状态"
                        width="240"
                    >
                        <template #default="{knowledge_status}">
                            <div class="status">
                                <div class="status-name">{{ knowledge_status | filterStatus }}</div>
                            </div>
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="domain"
                        title="领域"
                        width="160"
                    />
                    <veui-table-column
                        field="create_time"
                        title="创建时间"
                        width="240"
                    >
                        <template #default="{create_time}">
                            <div>{{ create_time }}</div>
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="operation"
                        title="操作"
                        width="120"
                        align="center"
                        fixed="right"
                    >
                        <template #default="{knowledge_status, id}">
                            <div>
                                <veui-button
                                    v-if="knowledge_status === 2 || knowledge_status === 3"
                                    ui="text"
                                    class="view-btn"
                                    @click="clickEdit(id)"
                                >
                                    编辑
                                </veui-button>
                                <veui-button
                                    v-if="knowledge_status === 2"
                                    ui="text"
                                    class="view-btn"
                                    @click="removeItem(id)"
                                >
                                    移除知识库
                                </veui-button>
                            </div>
                        </template>
                    </veui-table-column>
                </veui-table>
            </section>
            <!-- 分页 -->
            <section v-if="total" class="pagination">
                <veui-pagination
                    :page="pn"
                    :page-size="rn"
                    :total="total"
                    @redirect="pageChange"
                />
            </section>
            <div>
                <quesDetail
                    :open="isShowDetail"
                    :qa-info="qaInfo"
                    @showQaEdit="showQaEdit"
                    @hideDetail="hideDetail"
                />
            </div>
        </div>
        <!-- 没有上传过文件 -->
        <div v-else class="no-files">
            <div class="title">您还未没有上传文件至{{ userInfo.name }}律师的知识库</div>
            <div class="sub-title">一键上传您专属的案例内容、问答语料以及文章访谈等知识内容，提升智能体专业度，更快为您获取更多高价值用户！</div>
            <div class="upload-box">
                <fileUpload type="question" @addQa="addQa"/>
            </div>
        </div>
    </div>
</template>

<script>
// 问答语料列表页
import {Select, Input, DatePicker, Table, Column, Pagination, Button, Option} from 'veui';
import dayjs from 'dayjs';
import fileUpload from './fileUpload.vue';
import quesDetail from './quesDetail.vue';
import overflowTooltip from '../../../components/overflowTooltip.vue';
import {mapState} from 'vuex';

export default {
    name: '',
    components: {
        'veui-select': Select,
        'veui-input': Input,
        'veui-date-picker': DatePicker,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        'veui-button': Button,
        fileUpload,
        'veui-option': Option,
        quesDetail,
        overflowTooltip
    },
    data() {
        return {
            formData: {}, // 筛选数据
            statusList: [
                {
                    label: '知识库处理成功',
                    value: 2
                },
                {
                    label: '知识库处理中',
                    value: 1
                },
                {
                    label: '知识库处理失败',
                    value: 3
                }
            ],
            tableData: [],
            total: 0,
            pn: 1,
            rn: 10,
            selected: [],
            isShowDetail: false,
            qaInfo: {},
            hasQa: false
        };
    },
    props: {
        doaminOption: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    filters: {
        filterDate(date) {
            return date ? dayjs(date * 1000).format('YYYY-MM-DD HH:mm:ss') : '-';
        },
        filterStatus(status) {
            let list = ['', '知识库处理中', '知识库处理成功', '知识库处理失败'];
            return status ? list[status] : '-';
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.lawStore.userInfoNew?.lawyer_info || {}
        })
    },
    mounted() {
        this.handleSearch();
    },
    methods: {
        // 添加问答内容
        addQa() {
            this.qaInfo = {};
            this.$emit('addQa', {isOpenOldEdit: true});
        },

        /**
         * 问答列表筛选
         * @param {number} pn 页数
         */

        handleSearch(pn) {
            const {date, domain, status, question} = this.formData;
            if (pn && typeof pn === 'number') {
                this.pn = pn;
            }
            let params = {
                start_time: date?.[0] ? dayjs(date?.[0]).unix() : '',
                end_time: date?.[1] ? dayjs(date?.[1]).hour(23).minute(59).second(59).unix() : '',
                knowledge_status: status,
                title: question,
                faxingbao_domain: domain,
                pn: this.pn,
                rn: this.rn
            };
            this.getData(params);
        },
        goBack() {
            this.$emit('hideQaList');
        },
        hideDetail() {
            this.isShowDetail = false;
        },
        clickEdit(id) {
            let curData = this.tableData.find(item => item.id === id);
            this.qaInfo = curData;
            this.isShowDetail = true;
        },

        showQaEdit() {
            this.$emit('showQaEdit', {qaInfo: {...this.qaInfo, isFormList: true}, isOpenOldEdit: true});
        },
        /**
         * 获取问答列表
        */

        getData(params) {
            this.$http.get('/bp/api/content/getknowledge', {
                params
            }).then(res => {
                if (!res || +res.code !== 0) {
                    this.$toast.error(res && res.msg || '查询失败，请稍后重试');
                    return;
                }
                const data = res?.data || {};
                let {list = [], count} = data;
                this.tableData = list || [];
                if (this.tableData && this.tableData.length) {
                    this.hasQa = true;
                }
                this.total = count || 0;
            }).catch(err => {
                this.$normalizeResponseError(err);
            });
        },

        /**
         * 页面改变
         */

        pageChange(pn) {
            this.pn = pn;
            this.handleSearch();
        },
        /**
         * 从知识库中移除案例请求接口
         * @param {string} id 案例字符串,拼接
         */

        handleRemove(id) {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            this.$http.post('/bp/api/content/removeknowledge', {
                ids: id
            }).then(res => {
                this.isSubmit = false;
                if (!res || +res.code !== 0) {
                    this.$toast.error('问答移除失败，请稍后重试');
                    return;
                }
                this.$toast.success('已为您成功移除知识库已处理成功的问答移内容');
                this.selected = [];
                // 刷新列表
                this.handleSearch();
                this.$emit('removeSuccess');
            }).catch(err => {
                this.isSubmit = false;
                this.$toast.error('问答移移除失败，请稍后重试');
                this.$normalizeResponseError(err);
            });
        },
        removeItem(id) {
            this.handleRemove(id + '');
        },
        // 批量移除
        removeList() {
            if (!this.selected || this.selected.length === 0) {
                return;
            }
            let list = [];
            // 只有已处理成功的才能移除
            this.tableData.forEach(item => {
                this.selected.forEach(id => {
                    if (item.id === id && item.knowledge_status === 2) {
                        list.push(item.id);
                    }
                });
            });
            if (list.length === 0) {
                this.$toast.error('暂无可移除知识库的问答内容');
                this.selected = [];
                return;
            }
            this.handleRemove(list.join(','));
        }
    }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/law-table.less";

.qa-list {
    border-radius: 8px;
    border: 1px solid #fff;
    padding: 25px 0;
    position: relative;
    overflow: scroll;
    height: 100%;
    background: #fff;

    .header {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        line-height: 14px;
        display: flex;
        position: relative;
        border-bottom: 1px solid #e9ecf3;
        padding: 0 24px 25px;

        .go-back {
            position: relative;
            padding-left: 20px;
            cursor: pointer;

            &::before {
                height: 16px;
                width: 16px;
                position: absolute;
                content: "";
                left: 0;
                top: -1px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/left.png") no-repeat center / 100% 100%;
            }
        }

        .line {
            padding: 0 10px;
        }
    }

    .select-box {
        position: relative;
        padding: 24px;
        display: flex;
        align-content: center;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        line-height: 14px;
        text-align: left;

        .select-item {
            display: flex;
            align-items: center;
            margin-right: 24px;

            .select-label {
                margin-right: 14px;
                flex-shrink: 0;
            }

            .select-input {
                width: 154px;
                height: 40px;

                &.status {
                    width: 200px;
                }

                &.name {
                    .veui-focus {
                        box-shadow: none;
                    }
                }

                /deep/.veui-select {
                    width: 100%;

                    .veui-input {
                        height: 40px;
                        border: 1px solid #e9ecf3;
                        border-radius: 8px;
                    }

                    .veui-select-trigger {
                        padding-left: 11px;
                    }
                }
            }

            .select-domain {
                width: 295px;
                height: 40px;

                /deep/.veui-select {
                    width: 295px;
                    height: 40px;

                    .veui-select-trigger {
                        padding-left: 11px;
                    }

                    .veui-input {
                        height: 40px;
                        border: 1px solid #e9ecf3;
                        border-radius: 8px;

                        .veui-input-before {
                            overflow: scroll;
                            width: 280px;
                            height: 100%;
                        }
                    }
                }
            }

            .select-date {
                /deep/.veui-date-picker-range {
                    width: 260px;
                }

                /deep/.veui-date-picker-trigger {
                    height: 40px;
                    border: 1px solid #e9ecf3;
                    border-radius: 8px;
                }
            }

            .veui-input {
                width: 154px;
                height: 40px;
                border: 1px solid #e9ecf3;
                border-radius: 8px;
            }
        }
    }

    .operation-box {
        display: flex;
        margin-left: 24px;
        align-items: center;
        margin-bottom: 24px;

        .add-btn {
            width: 96px;
            height: 40px;
            border-radius: 5px;
            background: #05f;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #fff;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
        }

        .remove-btn {
            height: 40px;
            border-radius: 5px;
            background: #fff;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #1e1f24;
            line-height: 40px;
            text-align: left;
            margin-left: 20px;
            padding: 0 16px;
            border: 1px solid rgba(233, 236, 243, 1);
            cursor: pointer;

            &.veui-disabled {
                border-color: #e2e6f0;
                background-color: #f6f7fa;
                color: rgba(83, 98, 128, .5);
            }
        }
    }

    .content-list {
        padding: 0 24px;

        /deep/.veui-table [role="cell"] {
            height: 82px;
        }

        .view-btn {
            color: rgba(0, 85, 255, 1);
            cursor: pointer;
            margin: 0;
        }

        .name {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .title {
                white-space: nowrap;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 200px;
                text-align: justify;
            }
        }

        .status {
            display: flex;
            align-items: center;
        }
    }

    .pagination {
        margin-top: 25px;
        margin-right: 24px;
        text-align: right;
    }

    .no-files {
        position: relative;
        padding: 24px;

        .title {
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
            text-align: left;
        }

        .sub-title {
            margin-top: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #848691;
            line-height: 12px;
            text-align: left;
        }

        .upload-box {
            margin-top: 24px;
        }
    }
}
</style>